<app-page-layout>
  <div class="text-center mt-70">
    <img src="../../../../../assets/images/loading.png" />
    <nz-row style="justify-content: center" class="mt-40 f-14">
      Loading your experience...
    </nz-row>
  </div>
</app-page-layout>
